<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<div class="mdc-layout-grid__inner" [ngClass]="{'margin-bottom-5em': embedded}">
	<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
        <h1>{{ locale.translations['payment']['n209'] }}</h1>
    </div>

    <div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone price" *ngIf="queryPackage">
        <div>
            <i class="fas fa-shopping-basket"></i>
    
            <span>
                {{ queryPackage === 'premium' ? locale.translations['ads']['ad']['n41'] : locale.translations['ads']['ad']['n118'] }}
            </span>
        </div>
        
        <div>
            <i class="fas fa-coins"></i>
    
            <span>
                {{ queryPackage === 'premium' ? locale.translations['payment']['n222'] : locale.translations['payment']['n223'] }}
            </span>
        </div>
    </div>
    
    <div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
		<form [formGroup]="form" (ngSubmit)="onSubmit()">
			<div class="mdc-layout-grid__inner">
				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone margin-bottom-1em">
					<mat-form-field appearance="outline" class="suffix" hideRequiredMarker>
						<mat-label>{{ locale.translations['payment']['n210'] }}</mat-label>
                        <input matInput required type="tel" pattern="[0-9]{0,}" (keyup)="onKeyUp('adID')" formControlName="adID">
                        <i class="fas fa-hashtag" [ngClass]="{'pos-ltr': locale.lang === 'en', 'pos-rtl': locale.lang !== 'en'}"></i>
                        
                        <mat-hint>{{ locale.translations['payment']['n211'] }}</mat-hint>
					</mat-form-field>
				</div>
                
                <div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone margin-bottom-1em">
					<mat-form-field appearance="outline" *ngFor="let voucher of vouchers; let i=index" hideRequiredMarker>
						<mat-label>{{ locale.translations['payment']['n212'] }}</mat-label>
                        <input matInput required type="tel" pattern="[0-9]{0,}" (keyup)="onKeyUp(voucher)" [formControlName]="voucher">
                        <mat-icon matSuffix>credit_card</mat-icon>

                        <mat-hint *ngIf="i === vouchers.length - 1">{{ locale.translations['payment']['n213'] }}</mat-hint>
                    </mat-form-field>
                </div>

                <div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone" *ngIf="vouchers.length !== 3">
                    <button mat-stroked-button type="button" (click)="onAddVoucherControl()">{{ locale.translations['payment']['n219'] }}</button>
				</div>

				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
					<button mat-flat-button type="submit" color="primary" [disabled]="!form.valid || loading">{{ locale.translations['place-ad']['finish']['n77'] }}</button>
				</div>

				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone" *ngIf="embedded">
                    <a mat-button href="tel:07512347071">
						<mat-icon class="mat-icon-rtl-mirror">call</mat-icon>
						&nbsp;
						{{ locale.translations['footer']['n154'] }}
					</a>
				</div>
			</div>
		</form>
	</div>
</div>
